<template>
  <div class="control_point-requests">
    <ccs-header
      title="Заявки на изменение КТ"
      :info="false" nightTheme back/>
    <div class="control_point-requests-content">
      <div class="control_point-requests-actions">
        <nav-bar :dataFunction="getControlPointRequests" nightTheme noOrdering :extraParams="extraParams">
          <ccs-input type="dropdown" v-model="controlPointRequestType" placeholder="Тип заявки"
            :items="controlPointRequestTypes" :modifiers="['no_cancel']"/>
        </nav-bar>
      </div>
      <ccs-table :data="controlPointRequests" :columnsDefs="columnsDefs" :options="tableOptions">
        <template v-slot:status="props">
          {{ controlPointRequestStatus[props.row.status] }}
        </template>
        <template v-slot:type="props">
          {{ controlPointRequestTypesToText[props.row.type] }}
        </template>
        <template v-slot:initiator="props">
          {{ props.row.initiator.full_name || 'Произошла ошибка' }}
        </template>
        <template v-slot:actions="props">
          <v-icon v-if="permissionsStatus.isControlPointRequestModereateAllowed || permissionsStatus.isControlPointRequestViewAllowed"
            class="ccs-icon--primary ccs-icon--hover" name="edit"
            @click="openControlPointRequestByID(props.row.id)"/>
          <v-icon v-if="permissionsStatus.isControlPointRequestDeleteAllowed"
            class="ccs-icon--secondary ccs-icon--hover"
            name="trash" scale="0.9"
            @click="removeControlPointRequest(props.row)"/>
        </template>
        <template v-slot:changes="props">
          {{ Object.keys(props.row.changes).length }}
        </template>
      </ccs-table>
      <pagination :dataFunction="getControlPointRequests" nightTheme/>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import Header from '@/layouts/Header.vue';
import Table from '@/components/Table.vue';
import NavBar from '@/components/NavBar.vue';
import Input from '@/components/forms/Input.vue';
import Pagination from '@/components/Pagination.vue';

import { PermissionsList } from '@/helpers/permissions';

export default {
  name: 'FndOrganizations',
  components: {
    'ccs-header': Header,
    'ccs-table': Table,
    'ccs-input': Input,
    NavBar,
    Pagination,
  },
  data() {
    return {
      PermissionsList,
      columnsDefs: [{
        name: `status`,
        title: 'Статус',
        prop: 'status',
      }, {
        name: `type`,
        title: 'Тип',
        prop: 'type',
      }, {
        name: `created_at`,
        title: 'Дата создания',
        prop: 'created_at',
        type: 'date',
      }, {
        name: `initiator`,
        title: 'Инициатор',
        prop: 'initiator',
      }, {
        name: `changes`,
        title: 'Количество изменений',
        prop: 'changes',
      }, {
        name: `actions`,
        title: ``,
        prop: `id`,
        isActions: true,
      }],
      tableOptions: {
        hideBottomBorder: true,
        nightTheme: true,
      },
      controlPointRequestStatus: {
        opened: 'Открыта',
        approved: 'Одобрена',
        rejected: 'Отклонена'
      },
      controlPointRequestTypesToText: {
        general: 'Обычные',
        critical_control_point_closure: 'Закрытие ККТ',
      },
      controlPointRequestTypes: [{
        prop: null,
        text: 'Все заявки',
      }, {
        prop: 'general',
        text: 'Обычные',
      }, {
        prop: 'critical_control_point_closure',
        text: 'Закрытие ККТ',
      }],
      controlPointRequestType: null,
    };
  },
  computed: {
    ...mapState('session', ['user']),
    ...mapState('projects', ['controlPointRequests']),
    ...mapGetters('session', ['permissionsStatus']),
    extraParams() {
      return this.controlPointRequestType ? `type=${this.controlPointRequestType}` : null;
    }
  },
  methods: {
    ...mapActions('projects', ['getControlPointRequests', 'openControlPointRequestByID', 'deleteControlPointRequest']),
    async removeControlPointRequest(controlPointRequest) {
      try {
        await this.deleteControlPointRequest(controlPointRequest.id);
        this.$toasted.success('Заявка удалена');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
  created() {
    if (this.$route.query.control_point_request) {
      this.openControlPointRequestByID(this.$route.query.control_point_request);
    }
  },
};
</script>

<style lang="scss" scoped>
.control_point-requests {
  min-height: 100%;
  min-width: 100%;
  background: $surfaceDarker;

  &-content {
    margin: 0 33px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }

  &-actions {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }

}
</style>
